import {
  Divider,
  Grid2,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";

const Section4 = () => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Employment and Work-Related Data
      </Typography>
      <Typography sx={{ fontSize: "1.1rem" }} variant="body1" mb={2}>
        Soucient HRMS processes employment-related data required for daily
        workforce operations, including:
      </Typography>

      <Grid2 container spacing={2} ml={4} mb={2}>
        <Grid2 size={{ xs: 12 }}>
          <List sx={{ listStyleType: "disc", pl: 4 }}>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Attendance records (check-in and check-out)"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Leave applications and leave balances"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Work From Home (WFH) requests"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Permission requests"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Attendance regularization records"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Payroll information and payslips"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Performance evaluation data provided by reporting managers"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>
          </List>
        </Grid2>
      </Grid2>

      <Typography sx={{ fontSize: "1.1rem" }} variant="body1" mb={2}>
        Payslip information is available for employee download through the
        Application. Performance evaluation information displayed reflects
        managerial assessments and is intended strictly for internal review and
        employee development.
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Typography variant="h4" gutterBottom>
        Device and Technical Information
      </Typography>
      <Typography sx={{ fontSize: "1.1rem" }} variant="body1" mb={2}>
        Soucient HRMS is designed with a data-minimization approach. The
        Application does not collect:
      </Typography>
      <Grid2 container spacing={2} ml={4} mb={2}>
        <Grid2 size={{ xs: 12 }}>
          <List sx={{ listStyleType: "disc", pl: 4 }}>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="IP addresses"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Device identifiers or device models"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Operating system details"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary="Application usage analytics or behavioural data"
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>
          </List>
        </Grid2>
      </Grid2>

      <Typography sx={{ fontSize: "1.1rem" }} variant="body1" mb={2}>
        No technical or behavioural profiling of employees is performed.
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Typography variant="h4" gutterBottom>
        Application Permissions
      </Typography>
      <Typography sx={{ fontSize: "1.1rem" }} variant="body1" mb={2}>
        The Application requests only permissions that are essential for core
        functionality:
      </Typography>
      <Grid2 container spacing={2} ml={4} mb={2}>
        <Grid2 size={{ xs: 12 }}>
          <List sx={{ listStyleType: "disc", pl: 4 }}>
            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <b>Storage permission</b> for uploading profile images or
                    documents, where applicable
                  </>
                }
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>

            <ListItem sx={{ display: "list-item" }}>
              <ListItemText
                primary={
                  <>
                    <b>Notification permission</b> for attendance updates, leave
                    approvals, payroll alerts and official HR communications
                  </>
                }
                primaryTypographyProps={{
                  sx: { textAlign: "justify", fontSize: "1.1rem" },
                }}
              />
            </ListItem>
          </List>
        </Grid2>
      </Grid2>

      <Typography sx={{ fontSize: "1.1rem" }} variant="body1" mb={2}>
        The Application does not request access to contacts, microphones, or
        unrelated device features.
      </Typography>
      <Divider sx={{ my: 2 }} />
    </>
  );
};

export default Section4;
